module.exports = __webpack_public_path__ + "assets/65fd34f3e863df63867ab85c6c6e8bb0.mp3";